import React from 'react';
import { INVESTOR_MATCHING_PRICE_TEXT, InvestorMatchingButton } from './constants';

export default function InvestorMatching({
  companyId,
  userWantsToBeContacted,
}: {
  companyId: number;
  userWantsToBeContacted?: boolean;
}) {
  return (
    <div className="u-flex u-flex--column u-flex--gap-half">
      <h4 className="text-h4">Boost your funding round with investor matching</h4>
      <span>
        Investor matching will get you hot leads from our network and increase your chances of building relevant
        investor connections that unlock future capital. {INVESTOR_MATCHING_PRICE_TEXT}
      </span>
      <InvestorMatchingButton />
    </div>
  );
}
